// Is the person looking at this page signed in?
//
// Two independent ways to be signed in, and the browse page can meet either:
//
//  1. They finished (or part-finished) this flow, so an account was created at
//     email verification and the store holds its clientId.
//  2. They already had a theWorkbook account and arrived with a session — the
//     shared cwb-react storage is the only thing that knows about that, and it
//     is outside this app's Redux store.
//
// Kept as one predicate so pages never hand-roll half of the answer. Anything
// this decides is presentation only: it changes which sentence is offered, and
// nothing about it may gate access, because storage can be read-only, cleared,
// or simply stale.

// @ts-ignore - cwb-react ships no TypeScript definitions
import { getCurUser } from "cwb-react";

const hasSharedSession = (): boolean => {
  try {
    const user: any = getCurUser();
    if (!user) return false;
    // Shape varies by caller: some paths store { userId }, others { id: { userId } }.
    if (!(user.userId || (user.id && user.id.userId))) return false;
    // An actor's session only: an agent's (3) or a casting account's (2) gets the visitor's
    // sentence, not "go to your dashboard", which is the actors' dashboard. No type: as before.
    const type = user.userTypeId || (user.id && user.id.userTypeId);
    return type === undefined || type === null || String(type) === "8";
  } catch (e) {
    // A blocked or empty storage is a signed-out visitor, not an error.
    return false;
  }
};

export const isViewerAuthenticated = (clientId?: number | null): boolean =>
  !!clientId || hasSharedSession();

export default isViewerAuthenticated;
